var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75,2.83c-.05.29-.13.73-.21,1.16L18.43,9.66l-1.52,7.82a1.74,1.74,0,0,1-1.33,1.24A1.92,1.92,0,0,1,14,18.34c-1.06-.84-2.14-1.64-3.2-2.47-.12-.09-.18-.07-.28,0L8.6,17.64a1.13,1.13,0,0,1-1.86-.3,11.4,11.4,0,0,1-.6-1.67c-.34-1.08-.66-2.16-1-3.24A.35.35,0,0,0,5,12.25L1.61,11.12a2.35,2.35,0,0,1-.93-.54A1.28,1.28,0,0,1,.86,8.53a6,6,0,0,1,1-.48L9.78,4.7,17.5,1.46a1.89,1.89,0,0,1,1-.2A1.41,1.41,0,0,1,19.75,2.83ZM7.9,16.18l0,0,2.62-2.39a.74.74,0,0,1,.16.11L14,16.47c.31.24.61.48.92.7s.45.11.51-.17c.39-2,.77-4,1.16-5.94l1.44-7.38c.05-.29.11-.58.18-.92L1.94,9.63l.12,0,4.05,1.37A.45.45,0,0,0,6.53,11q4.18-2.61,8.39-5.2a5.79,5.79,0,0,1,.64-.36.32.32,0,0,1,.3,0c.1.09,0,.22,0,.32l-.29.28c-2.31,2.16-4.63,4.31-6.94,6.48a.55.55,0,0,0-.16.3c-.11.65-.2,1.31-.3,2C8.05,15.26,8,15.72,7.9,16.18Z",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramApp);
export default __webpack_public_path__ + "static/media/telegram-app.6b48564681ed8503e5bebb14282ed0ca.svg";
export { ForwardRef as ReactComponent };